import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { CatalogPhaseEventsReducer } from "./CatalogPhaseEventsReducer";

const CatalogPhaseEventsContext = createContext({
	state: CatalogPhaseEventsReducer.getInitialState(),
	actions: CatalogPhaseEventsReducer.actions,
});

export const useCatalogPhaseEventsContext = () =>
	useContext(CatalogPhaseEventsContext);

export const CatalogPhaseEventsProvider = ({
	children,
}: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: CatalogPhaseEventsReducer.getInitialState(),
		reducers: CatalogPhaseEventsReducer.caseReducers,
	});
	return (
		<CatalogPhaseEventsContext.Provider value={{ state, actions }}>
			{children}
		</CatalogPhaseEventsContext.Provider>
	);
};
